var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-inner bg-brand-gradient"},[_c('div',{staticClass:"page-content-wrapper bg-transparent m-0"},[_c('start-header'),_c('start-body'),_c('start-footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }